import styled from 'styled-components';
import {BigBackButton, FlexFullGrow, IconBigClose} from '@/styled-components';
import {LAYOUT_SIZE, LAYOUT_Z_INDEX, palette} from '@/styles';
import {Typography} from '../Typography';

interface IProps {
  title?: string;
  onPrev?(): void;
  onClose?(): void;
}

export const MobileNavigator = ({title, onPrev, onClose}: IProps) => {
  return (
    <Root>
      {!!onPrev ? <BigBackButton onClick={onPrev} /> : <BlankSpace />}
      <FlexFullGrow>
        {!!title?.length && (
          <Typography variant="medium16" as="div" align="center">
            {title}
          </Typography>
        )}
      </FlexFullGrow>
      {!!onClose ? <IconBigClose onClick={onClose} /> : <BlankSpace />}
    </Root>
  );
};

const Root = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  height: ${LAYOUT_SIZE.NAV_HEIGHT}px;
  width: 100%;
  background-color: ${palette.white};
  border-bottom: solid 1px ${palette.gray200};
  padding: 0 16px;
  z-index: ${LAYOUT_Z_INDEX.NAVBAR};
`;

const BlankSpace = styled.div`
  width: 24px;
  height: 24px;
`;
